import { useMutation, useQueryClient } from '@tanstack/react-query';
import { invalidateListResource } from '../../../../lib/query/invalidateResource';
import { notification } from 'antd';
import { createCustomerSegment } from '../api/customerSegments';
import type { CustomerSegmentFormValues } from '../types';

export function useCreateCustomerSegment(onSuccess?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CustomerSegmentFormValues) => createCustomerSegment(data),
    onSuccess: () => {
      notification.success({ message: 'Customer segment created successfully' });
      invalidateListResource(queryClient, 'customer-segments');
      void queryClient.invalidateQueries({ queryKey: ['settings-contact-categories'] });
      void queryClient.invalidateQueries({ queryKey: ['contact-categories'] });
      onSuccess?.();
    },
    onError: () => {
      notification.error({ message: 'Failed to create customer segment' });
    },
  });
}
